import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import unescapedText from 'I18n/utils/unescapedText';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import * as TierGroup from '../../constants/groupTags/TierGroup';
import FilterToggleGroup from './filterToggleGroup';
import { getTierI18nKey, getTierHubI18nKey // @ts-expect-error untyped dependency
} from '../../utils/i18n';

/* Ensure consistent order */
const tierGroupNames = ['CRM', 'MARKETING', 'SALES', 'SERVICE', 'CMS', 'OPERATIONS'];

function getTierOption(tier) {
  return {
    text: unescapedText(getTierI18nKey(tier)),
    value: tier
  };
}

function getTierOptions(validTierGroups) {
  const validTierGroupNames = validTierGroups ? tierGroupNames.filter(group => validTierGroups.includes(group)) : tierGroupNames;
  return validTierGroupNames.map(group => {
    const tiers = TierGroup[group];
    if (tiers.length === 1) return getTierOption(tiers[0]);
    return {
      options: tiers.map(getTierOption),
      selectAll: true,
      text: unescapedText(getTierHubI18nKey(group))
    };
  });
}

export default function PlanCompatibilityFilter({
  ariaLabel,
  appContext,
  onChange,
  validTierGroups,
  value
}) {
  const {
    portalCompatible,
    tiers
  } = value;

  const handleTierChange = event => {
    const eventValue = event.target.value;
    const newValue = {
      portalCompatible: false,
      tiers: eventValue
    };
    onChange(SyntheticEvent(newValue, event.source));
  };

  const handleCompatibilityChange = event => {
    const newValue = event.target.checked ? {
      portalCompatible: true,
      tiers: []
    } : {
      portalCompatible: false,
      tiers
    };
    onChange(SyntheticEvent(newValue, event));
  };

  const isInApp = appContext === 'app';
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [isInApp && /*#__PURE__*/_jsx(UICheckbox, {
      checked: portalCompatible,
      onChange: handleCompatibilityChange,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystemMarketplaceCore.compatibility.planCompatibilityFilter.portalCompatible"
      })
    }), /*#__PURE__*/_jsx(FilterToggleGroup, {
      ariaLabel: ariaLabel,
      disabled: portalCompatible,
      multi: true,
      name: "plan-compatibility-filter",
      onChange: handleTierChange,
      options: getTierOptions(validTierGroups),
      value: tiers
    })]
  });
}